export default {
    GET_EMAIL_BY_DATE: (query, selectedBoardId) => `/email/getEmailsByDate/${selectedBoardId}?${query}`,
    UPDATE_EMAIL_STATUS: (id) => `/email/updateStatusEmail/${id}`,
    EMAIL_REPLY: (id) => `/email/reply/${id}`,
    GET_ALL_DELETED_EMAIL: () => `/email/getAllDeletedMail`,
    GET_TASK_BY_ID: (id) => `/getTaskBy/${id}`,
    EMAIL_UPDATEMESSAGE_READ: (id) => `/email/updatedMessageRead/${id}`,
    UPDATED_EMAIL_FOR_TASK: (id) => `/email/updatedEmailForTask/${id}`,
    Get_The_Linked_Email: (isMailSend) => `/email/getTheLinkedEmail?${isMailSend ? isMailSend : ""}`,
    CreateEmailUser: () => '/credentail/createCredentail',
    updateEmailUser: (id) => `/credentail/updateTokenWithClientId/${id}`,
    GET_ALL_CLIENT: () => '/email/getTheLinkedEmail',
    EMAIL_SEARCH_BY_QUERY: (emails, query) => `/email/search?email=${emails}&search=${query}`,
    GET_EMAIL_BY_SELECTED_USER: (query) => `/email/getAllInboxEmail?${query}`,
    GET_ALL_CREDENTIALS_EMAIL: () => '/credentail/getAllCredentials',
    GET_TASK_GMAILMESSAGE_ID: (id) => `/task/getTaskBythreadId/${id}`,
    GET_SENT_MAIL: (page, limit,gmailUserId,search) => `/email/getAllSentMail?page=${page}&limit=${limit}&gmailUserId=${gmailUserId}&search=${search}`,
    UPDATE_EMAIL_SENDMAIL: (id) => `/gmailUser/update/${id}`,
    GET_ALL_MAILS: (gmailUserId, page, limit, search) => `/email/getAllEmails?gmailUserId=${gmailUserId}&page=${page}&limit=${limit}&search=${search}`,
    SYNC_OLD_MAIL: () => `/email/syncOldEmails`,
};
